import { utils } from "@/utils/utils"

const redirectToLoginPage = () => {
  const authnzURL = process.env.VUE_APP_AUTH_URL
  const frontURL = process.env.VUE_APP_APP_URL
  if (!utils.ValidateDeltaDomain(authnzURL) || !utils.ValidateDeltaDomain(frontURL)) {
    return
  }
  window.location.href = `${authnzURL}#/auth/login?redirectUrl=` + encodeURIComponent(`${frontURL}#`)
}

export {redirectToLoginPage}